<form #f="ngForm" [formGroup]="settingsAddForm">
  <div class="container-fluid">
    <strong class="align-items-center d-flex">{{ "envelope.settings.information" | translate | titlecase }}
      <fa-icon ngbTooltip="{{ 'envelope.settings.tooltip.informationSettings' | translate }}" class="ml-2 fa-gray"
        data-placement="bottom" size="sm" [icon]="['fas', 'question-circle']">
        </fa-icon>
    </strong>
    <div class="form-row">
      <div class="col-md-6">
        <div [ngClass]="{'has-error': titleEnvelope.invalid && (titleEnvelope.dirty || titleEnvelope.touched)}"
          class="form-group mb-4">
          <label for="titleEnvelope" class="mb-1">{{ "titleEnvelope" | translate}}<i
              class="gray-30 ml-1">{{"(mandatory)" | translate | titlecase}}</i></label>
          <div class="inputWithIcon-left">
            <input type="text" class="form-control" id="titleEnvelope" formControlName="titleEnvelope"
              placeholder="{{ 'titleEnvelopeExample' | translate }}" (keydown.enter)="$event.preventDefault()" (blur)="setReplaceTitle()" />
            <fa-icon [icon]="['fas','envelope-open-text']"></fa-icon>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-12 mt-0 mb-4">
            <label class="d-flex justify-content-between mb-1">
              {{ "language" | translate | titlecase }}
              <fa-icon ngbTooltip="{{ 'envelope.settings.tooltip.languageSettings' | translate }}" class="ml-1"
                size="sm" [icon]="['fas', 'question-circle']">></fa-icon>
            </label>
            <cdx-dropdown [options]="languageEnvelopedropdown" [selectedItem]="languageSelected"
              (onSelectItem)="onLanguageSelectItem($event)"></cdx-dropdown>
          </div>
        </div>
        <strong class="align-items-center d-flex mb-2">
          {{ "envelope.settings.additionalInformation" | translate }}
        </strong>
        <div class="form-group mt-0 mb-4" 
          [ngClass]="{'has-error': settingsAddForm.get('expiration').hasError('dateInvalid')}">
          <label class="mb-1">{{ "expiration" | translate }}</label>
          <cdx-date-picker-container [options]="datePickerContainerOptions" [model]="datePickerContainerModel"
            (onSelectedDate)="onExpirationSelectItem($event)" (keydown.enter)="$event.preventDefault()">
          </cdx-date-picker-container>
        </div>
        <div class="form-group mb-4" *ngIf="showSegment()">
          <label class="justify-content-between mb-1">
              {{ "envelope.settings.segmentText" | translate | titlecase }} <i
              *ngIf="isRequiredUserSegment" class="gray-30 ml-1">({{ 'required' | translate }})</i> 
            <fa-icon ngbTooltip="{{ 'envelope.settings.tooltip.segmentSettings' | translate }}" class="ml-1"
            size="sm" [icon]="['fas', 'question-circle']">></fa-icon>
            </label>
          <cdx-dropdown [options]="segmentdropdown" [selectedItem]="segmentSelected"
            (onSelectItem)="onSegmentSelectItem($event)" (click)="showModalSegment(confirmModal)">
          </cdx-dropdown>
          <span>{{ "envelope.settings.textHelper.segmentTextHelper" | translate }}</span>
          
        </div>
        <div class="form-row mt-0 ml-0">
          <label class="toggleRejectLabel">{{ "envelope.settings.toggle.reject" | translate }}</label>
          <div class="before-label" >
            <cdx-toggle-switch class="toggleRejec" [toggledOn]="rejectToggleSelected" (toggle)="onRejectToggle($event, true)" ></cdx-toggle-switch>
          </div>
          <fa-icon ngbTooltip="{{ 'envelope.settings.tooltip.rejectSettings' | translate }}" class="ml-2"
                size="sm" [icon]="['fas', 'question-circle']">></fa-icon>
        </div>
      </div>
      <div class="col-md-6 mb-4">
        <div class="form-group">
          <label for="message" class="mb-1">{{
            "message" | translate
            }}</label>
          <textarea class="form-control form__message" rows="12" id="message" formControlName="message"
            placeholder="{{ 'messageExample' | translate }}"></textarea>
        </div>
      </div>
    </div>
    <div class="form-row mt-3">
      <div class="col-md-6">
        <cdx-card-collapse [isCollapsed]="false" [headerOptions]="fileCardCollapse" *ngIf="canShowUploads()">
          <div class="header">
            {{ "envelope.settings.atachedFiles" | translate }}
          </div>
          <div class="body">
            <div *ngFor="let file of uploads$; let i = index">
              <div class="file">
                <span class="text-truncate"> {{ file.name }}</span>
                <div *ngIf="file.upload === true">
                  <fa-icon [icon]="['fas','times-circle']" (click)="removeFile(i)"></fa-icon>
                </div>
              </div>
            </div>
          </div>
        </cdx-card-collapse>
      </div>
    </div>
  </div>
</form>

<ng-template #confirmModal>
  <app-alert-modal-ok [MessageText]="'envelope.main-envelope.message-segment-modal.messageText'"
    [HeaderText]="'envelope.main-envelope.alert-modal.headerText'" (closeModalClick)="confirmModalClose()"
    (confirmModalClick)="confirmModalYesClick()">
  </app-alert-modal-ok>
</ng-template>
